import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/home";
import History from "./pages/history";
import Login from "./pages/login";
import Navigation from "./components/MaterialUi/NavigationMUI";
import { userAuth } from "./redux/actions/index";
import { connect } from "react-redux";
import BarChart from "./components/General/BarChart";
import UserGuide from "./pages/userGuide";
import Logout from "./pages/logout";

const hostUrl = process.env.REACT_APP_HOST ? process.env.REACT_APP_HOST : "";

class Nav extends Component {
  render() {
    return (
      <Navigation history={this.props.history}>
        <Route path="/" exact component={Home}></Route>
        <Route path="/login" exact component={Login}></Route>
        <Route path="/logout" exact component={Logout}></Route>
        <Route path="/historyView" exact component={History}></Route>
        <Route path="/barChart" exact component={BarChart}></Route>
        <Route path="/userGuide" exact component={UserGuide}></Route>
      </Navigation>
    );
  }
}

class App extends Component {
  componentDidMount() {
    // axios
    //   .get(`${hostUrl}/api/auth`)
    //   .then((response) => {
    //     console.log("Response in Auth", response.data);
    //     this.props.userAuth(response.data);
    //   })
    //   .catch((err) => {
    //     console.log("Error", err.message);
    //   });
  }

  render() {
    return (
      <React.StrictMode>
        <BrowserRouter>
          <Route to="/" component={Nav} />
        </BrowserRouter>
      </React.StrictMode>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    reduxState: state,
  };
};
export default connect(mapStateToProps, { userAuth })(App);
